export default __webpack_public_path__ + "static/media/espago-screenshot-06.20b24cd4.png";